import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './Header.css';
import logo from '../assets/logo2.png';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    // set CSS var for header height to support CSS scroll-margin-top fallbacks
    const applyHeaderHeightVar = () => {
      const headerEl = document.querySelector('header.header');
      if (headerEl) {
        document.documentElement.style.setProperty('--header-height', `${headerEl.offsetHeight}px`);
      }
    };

    applyHeaderHeightVar();
    window.addEventListener('resize', applyHeaderHeightVar);
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('resize', applyHeaderHeightVar);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Helper: smooth-scroll to an element by id with offset for fixed header
  const scrollToSectionById = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    const headerEl = document.querySelector('header.header');
    const offset = headerEl ? headerEl.offsetHeight : 0;
    const y = el.getBoundingClientRect().top + window.scrollY - offset - 4; // small gap
    window.scrollTo({ top: y, behavior: 'smooth' });
  };

  // Handle scrolling to section after navigation
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      // wait for DOM to paint after navigation
      const t = setTimeout(() => {
        scrollToSectionById(id);
      }, 100);
      return () => clearTimeout(t);
    }
  }, [location]);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    scrollToTop()
    setIsMobileMenuOpen(false);
  };

  const handleNavClick = (e, sectionId) => {
    e.preventDefault();
    closeMobileMenu();

    // If we're not on home page, navigate to home first
    if (location.pathname !== '/') {
      navigate(`/#${sectionId}`);
    } else {
      // If we're on home page, just scroll to section with offset
      scrollToSectionById(sectionId);
    }
  };

  return (
    <>
      <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
        <div className="container">
          <div className="nav-container">
            <Link to="/" className="nav-logo" onClick={() => { closeMobileMenu(); scrollToTop(); }}>
              <div className="logo-text">
                <img className='logo-img' src={logo} alt="logo" />
              </div>
            </Link>

            <nav className={`nav-menu ${isMobileMenuOpen ? 'active' : ''}`}>
              <div className="nav-links">
                <a
                  href="#about"
                  className="nav-link"
                  onClick={(e) => handleNavClick(e, 'about')}
                >
                  ABOUT
                </a>
                <a
                  href="#story"
                  className="nav-link"
                  onClick={(e) => handleNavClick(e, 'story')}
                >
                  STORY
                </a>
                <a
                  href="#why"
                  className="nav-link"
                  onClick={(e) => handleNavClick(e, 'why')}
                >
                  WHY
                </a>
                <a
                  href="#resources"
                  className="nav-link"
                  onClick={(e) => handleNavClick(e, 'resources')}
                >
                  RESOURCES
                </a>
              </div>
            </nav>

            <div className="nav-actions">
              <Link to="/verify" className="btn btn-verify" onClick={closeMobileMenu}>
                Verify
              </Link>
              <Link to="/verify" className="btn btn-primary" onClick={closeMobileMenu}>
                Join InnerCircle
                <span className="">
                  <img src="./assets/icons/crown.svg" alt="crown" />
                </span>
              </Link>
            </div>



            <div className="mobile-verify-btn-container">
              <Link to="/verify" className="btn btn-verify mobile-verify-only" onClick={closeMobileMenu}>
                Verify
              </Link>
            </div>

            <button
              className={`nav-toggle ${isMobileMenuOpen ? 'active' : ''}`}
              onClick={toggleMobileMenu}
              aria-label="Toggle menu"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <div className="mobile-overlay" onClick={closeMobileMenu}></div>
      )}
    </>
  );
};

export default Header;